import { render, staticRenderFns } from "./FilterItemCard.vue?vue&type=template&id=6cc4150e&scoped=true"
import script from "./FilterItemCard.vue?vue&type=script&lang=js"
export * from "./FilterItemCard.vue?vue&type=script&lang=js"
import style0 from "./FilterItemCard.vue?vue&type=style&index=0&id=6cc4150e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc4150e",
  null
  
)

export default component.exports